import { motion } from 'framer-motion'
import { Monitor } from 'lucide-react'

const LocauxMateriels = () => {
  // Liste des images reçues dans l'ordre
  const images = [
    { src: "/images/Siege.jpg", alt: "Localisation du siège social" },
    { src: "/images/local1.jpg", alt: "Localisation ex-sous-bureau Boundiali" },
    { src: "/images/Man.jpg", alt: "Localisation sous-bureau Man" },
    { src: "/images/voiture1.jpg", alt: "Matériel roulant CIDH Consulting 1" },
    { src: "/images/voiture2.png", alt: "Matériel roulant CIDH Consulting 2" },
    { src: "/images/moto.jpg", alt: "5 motos" }
  ]

  const materielsDidactiques = [
    { no: 1, designation: "Ordinateurs de Bureau", qte: "03", annee: "2023, 2022, 2021", description: "(6 COMPAQ et 6 DELL) Pentium 4, XP Pro, Logiciel Office 2007, Secrétariat, comptabilité, Commercial, Etudes de projets.", observations: "Bon état Propriété CIDH" },
    { no: 2, designation: "Ordinateurs portables", qte: "11", annee: "2023, 2022, 2021, 2020", description: "(7 TOSHIBA, 2 COMPAQ et 2 HP) Pentium 4, XP Pro, Logiciel Office 2007, Direction Générale, Formation, Gestion/coordination de projets.", observations: "Bon état Propriété CIDH" },
    { no: 3, designation: "Imprimantes", qte: "05", annee: "2023, 2022, 2021", description: "3 imprimantes Couleur HP Jet d'encre et Canon IP1800, 1 imprimante Blanc noir HP 1005 Laser", observations: "Bon état Propriété CIDH" },
    { no: 4, designation: "Scanner", qte: "2", annee: "2023, 2022", description: "2 scanners MIRA", observations: "Bon état Propriété CIDH" },
    { no: 5, designation: "Appareils photos numériques", qte: "2", annee: "2023, 2021", description: "(1 SAMSUNG 7.2MP, 1 SONY 8MP) Formation, Gestion de projets.", observations: "Bon état Propriété CIDH" },
    { no: 6, designation: "Caméra numérique", qte: "1", annee: "2022", description: "1 Caméscope Panasonic pour les prises de vue /, séminaires, gestion de Formation projets.", observations: "Bon état Propriété CIDH" },
    { no: 7, designation: "Vidéoprojecteur", qte: "6", annee: "2023, 2022, 2021", description: "TOSHIBA pour les formations/ Séminaires et présentations PowerPoint", observations: "Bon état Propriété CIDH" },
    { no: 8, designation: "Tableaux PADEX", qte: "4", annee: "2020, 2018", description: "Pour formation et séminaire", observations: "Bon état Propriété CIDH" },
    { no: 9, designation: "Tableau émaillé", qte: "1", annee: "2009", description: "Pour formation", observations: "Bon état Propriété CIDH" },
    { no: 10, designation: "Poste téléviseur couleur grand écran", qte: "6", annee: "2023, 2022, 2021", description: "Pour formation", observations: "Bon état Propriété CIDH" }
  ]

  return (
    <div className="pt-24 pb-16 min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-cidh-blue py-12 mb-12 relative overflow-hidden">
        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-5xl font-bold text-white mb-6 font-montserrat"
          >
            Nos Locaux et Matériels
          </motion.h1>
          <div className="w-24 h-1.5 bg-cidh-gold mx-auto"></div>
        </div>
      </section>

      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-5xl mx-auto flex flex-col gap-8">
          {images.map((img, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="w-full shadow-lg rounded-lg overflow-hidden border border-gray-100"
            >
              <img 
                src={img.src} 
                alt={img.alt} 
                className="w-full h-auto block"
                onError={(e) => {
                  e.target.src = `https://placehold.co/1200x800/e2e8f0/1e3a8a?text=Image+${index + 1}+à+ajouter`;
                }}
              />
            </motion.div>
          ))}

          {/* Table Section */}
          <motion.section 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-16 mb-8 overflow-hidden"
          >
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-12 rounded-xl bg-cidh-blue/10 flex items-center justify-center text-cidh-blue shrink-0">
                <Monitor size={24} />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-cidh-blue font-montserrat uppercase tracking-tight border-b-4 border-cidh-gold pb-2">
                LISTE DES MATÉRIELS DIDACTIQUES
              </h2>
            </div>

            <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-cidh-blue/5 text-cidh-blue border-b border-gray-200">
                    <th className="px-4 py-4 font-bold uppercase text-sm w-12 text-center bg-[#92d050]">N°</th>
                    <th className="px-6 py-4 font-bold uppercase text-sm bg-[#92d050]">DESIGNATION</th>
                    <th className="px-4 py-4 font-bold uppercase text-sm w-16 text-center bg-[#92d050]">QTE</th>
                    <th className="px-4 py-4 font-bold uppercase text-sm w-24 text-center bg-[#92d050]">ANNEE</th>
                    <th className="px-6 py-4 font-bold uppercase text-sm bg-[#92d050]">DESCRIPTION</th>
                    <th className="px-6 py-4 font-bold uppercase text-sm bg-[#92d050]">OBSERVATIONS</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {materielsDidactiques.map((item) => (
                    <tr key={item.no} className="hover:bg-gray-50 transition-colors">
                      <td className="px-4 py-4 text-center font-bold text-cidh-blue">{item.no}</td>
                      <td className="px-6 py-4 font-medium text-gray-900">{item.designation}</td>
                      <td className="px-4 py-4 text-center text-gray-700 font-semibold">{item.qte}</td>
                      <td className="px-4 py-4 text-center text-gray-600 whitespace-pre-line text-xs font-bold leading-tight align-top pt-5">
                        {item.annee.split(', ').join('\n')}
                      </td>
                      <td className="px-6 py-4 text-gray-600 text-sm leading-relaxed">{item.description}</td>
                      <td className="px-6 py-4 text-gray-600 text-sm leading-relaxed italic">{item.observations}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </motion.section>
        </div>
      </div>
    </div>
  )
}

export default LocauxMateriels
